import type { FC } from "react";
import { useYearsLabel } from "web_myplann/Calculators/Hooks/useYearsLabel";
import {
	getResourcePath,
	Resources,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatCurrency } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import { EmphasisNote } from "web_myplann/Shared/Components/EmphasisNote";
import { CurrencyCode } from "web_myplann/Shared/constants";

type Props = {
	years: number;
	later: number;
	extra: number;
};

export const CalculatorWaitingNote: FC<Props> = ({ years, later, extra }) => {
	const yearsLabel = useYearsLabel();

	return (
		<EmphasisNote
			i18nKey={getResourcePath(Resources.Calculators.Result.WaitingNote)}
			values={{
				years: yearsLabel(years),
				later: formatCurrency(later, CurrencyCode.CZK, 0),
				extra: formatCurrency(extra, CurrencyCode.CZK, 0),
			}}
		/>
	);
};
